import posthog from "posthog-js"
import { isHttpError, isNetworkError } from "@/shared/api/errors"

/** Шаг жизни голосового, на котором случился сбой; что именно сломалось — в code. */
export type VoiceErrorStage =
	// Запись
	| "permission" // нет доступа к микрофону
	| "hold" // сервер не зарезервировал сообщение
	| "record" // сбой самой записи
	| "publish" // готовая запись не отправилась
	// Доска
	| "load" // не загрузилось сообщение
	| "url" // не получена ссылка на аудио
	| "playback" // плеер не воспроизвёл
	| "finish" // не отметилось прослушанным
	| "delete" // не удалилось

export function requestErrorCode(error: unknown): string {
	if (isHttpError(error)) return `http_${error.status}`
	if (isNetworkError(error)) return "network"
	return "unknown"
}

/**
 * Единое событие voice_error; durationMs есть только у этапов с готовым сообщением.
 * code: http_<status> | network | unknown для запросов, RecorderError.kind для записи,
 * timeout для publish, tapToResume | playbackFailed для плеера.
 */
export function reportVoiceError(
	stage: VoiceErrorStage,
	code: string,
	durationMs?: number,
) {
	posthog.capture("voice_error", {
		durationMs,
		stage,
		code,
	})
}
